import { MARKETING_CONSENT_RENEWAL_DIALOG_ID } from "@obg/mat.ui.common";
import { DialogLike } from "@obg/mat.ui.core";

import { MarketingConsentRenewalComponent } from "./marketing-consent-renewal.component";

export const MARKETING_CONSENT_RENEWAL_DIALOG: DialogLike<MarketingConsentRenewalComponent> = {
	dialogId: MARKETING_CONSENT_RENEWAL_DIALOG_ID,
	gtmIdentifier: "CRM_PreferencePopup",
	dialogComponentType: MarketingConsentRenewalComponent,
};
